import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const Base64Image = ({ image, alt = '', style }) => {
  if (!image || !image.data || !image.contentType) {
    return null;
  }

  const src = `data:${image.contentType};base64,${image.data}`;

  return (
    <LazyLoadImage
      src={src}
      alt={alt}
      effect="blur"
      style={style}
    />
  );
};

export default Base64Image;
